import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import ReportFilters from './ReportFilters';


const useStyles = makeStyles(theme => ({
    paper: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(3),
    },
    table: {
        minWidth: 650,
        '& td:nth-child(3)': {
            width: 150,
        },
        '& th:nth-child(3)': {
            width: 150,
        },
    },
    tableHeader: {
        backgroundColor: theme.palette.primary.main,
        '& .MuiTableCell-head': {
            color: theme.palette.primary.contrastText,
        },
    },
}));

const OfficiantsReport = () => {
    const classes = useStyles();
    const reportUrl = '/api/reports/officiants';
    const reportTitle = 'Officiants Report';
    const pageTitle = `${reportTitle} - Enduring Promises`;
    const [data, setData] = React.useState(null);
    const [loading, setLoading] = React.useState(true);

    const [state, setState] = React.useState({
        dummy: '',
    });

    const getData = state => {
        new Promise((resolve, reject) => {
            fetch(`${reportUrl}`)
                .then(response => {
                    return response.json();
                })
                .then(result => {
                    setData(result);
                    resolve();
                })
                .finally(() => {
                    setLoading(false);
                });
        });
    };

    useEffect(() => {
        document.title = pageTitle;
        getData(state);
    }, [1]);

    const handleSubmit = () => {
        getData(state);
    };

    return (
        <Paper square className={classes.paper}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="h6">{reportTitle}</Typography>
                </Grid>
                <Grid item xs={12}>
                    <TableContainer component={Paper} variant="outlined" square>
                        <Table className={classes.table} size="small">
                            <TableHead className={classes.tableHeader}>
                                <TableRow>
                                    <TableCell align="left">Name</TableCell>
                                    <TableCell align="left">Email</TableCell>
                                    <TableCell align="left">Phone</TableCell>
                                    <TableCell align="center">Province</TableCell>
                                    <TableCell align="center">Location</TableCell>
                                    <TableCell align="left">Profile</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            {!loading && data !== null && data.map((row, i) => {
                                const profileLink = row.officiant_info ? row.officiant_info.profile_link : '';
                                return (
                                    <TableRow key={`row-${i}`}>
                                        <TableCell align="left">{row.name}</TableCell>
                                        <TableCell align="left">{row.email}</TableCell>
                                        <TableCell align="left">{row.phone_number}</TableCell>
                                        <TableCell align="center">{row.province ? row.province.province_name : ''}</TableCell>
                                        <TableCell align="center">{row.officiant_info ? row.officiant_info.location : ''}</TableCell>
                                        <TableCell align="left">{profileLink ? <Link target="_blank" href={profileLink}>{profileLink.replace('https://', '')}</Link> : ''}</TableCell>
                                    </TableRow>
                                )
                            })}
                            {!loading && data !== null && data.length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={6} align="center">No data</TableCell>
                                </TableRow>
                            )}
                            {loading && (
                                <TableRow>
                                    <TableCell colSpan={6} align="center">
                                        <CircularProgress color="primary" />
                                    </TableCell>
                                </TableRow>
                            )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
        </Paper>
    );
}

export default OfficiantsReport;
